export default __webpack_public_path__ + "static/media/amazon-alexa-tower-clock-tower-building.50b0937e.png";